<template>
    <div class="db-regist-out" v-if="isRegist">
        <div class="db-regist-in">
            <div class="container-fluid">
                <div class="row mt-2">
                    <div class="col-md-12 mb-2 pt-1">
                        <div class="row">
                            <div class="col-md-6 mb-1"></div>
                            <div class="col-md-3 mb-1">
                                <button class="btn btn-outline-dark w-100" @click="cancel()">취소</button>
                            </div>
                            <div class="col-md-3 mb-1">
                                <button class="btn btn-success w-100" @click="regist()">등록</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-2">
                        <div class="card">
                            <div class="card-header pb-0">
                                <h6><i class="fas fa-check text-success text-sm opacity-10"></i> DB 등록</h6>
                                <p><i class="fas fa-user text-dark text-sm opacity-10"></i> {{ planner }} &nbsp;&nbsp;<i class="fas fa-calendar-day text-dark text-sm opacity-10"></i> {{ year }}/{{ month }}</p>
                            </div>
                            <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-md-4 mb-2">
                                        <div class="mb-2">
                                            <label for="regName" class="form-control-label">고객명 *</label>
                                            <input id="regName" class="form-control" v-model="regName" placeholder="고객명"/>
                                        </div>
                                        <!-- <div class="mb-2">
                                            <label for="regRegion" class="form-control-label">지역 *</label>
                                            <select id="regRegion" class="form-control" v-model="regRegion">
                                                <option selected="selected" value="">지역선택</option>
                                                <option v-for="(region, i) in regions" :key="i" :value="region.name">{{ region.name }}</option>
                                            </select>
                                        </div> -->
                                    </div>
                                    <div class="col-md-4 mb-2">
                                        <div class="mb-2">
                                            <label for="regNumber" class="form-control-label">생년월일 *</label>
                                            <input id="regNumber" class="form-control" v-model="regNumber" placeholder="ex)760125"/>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-2">
                                        <div class="mb-2">
                                            <label for="regHospital" class="form-control-label">치과 *</label>
                                            <select id="regHospital" class="form-control" v-model="regHospital">
                                                <option selected="selected" value="">치과선택</option>
                                                <option v-for="(hospital, i) in hospitals" :key="i" :value="hospital.name">{{ hospital.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dbRegist',

    data(){
        return {
            regName: '',
            regNumber: '',
            // regRegion: '',
            regHospital: '',
        }
    },

    props: {
        isRegist: Boolean,
        planner: String,
        planner_id: Number,
        year: Number,
        month: String,
        toggleRegist: Function,
        getAllRequestDB: Function,
    },

    methods:{
        initPage(){
            this.regName = '';
            this.regNumber = '';
            // this.regRegion = '';
            this.regHospital = '';
        },

        cancel(){
            this.initPage();
            this.toggleRegist();
            this.getAllRequestDB();
        },

        regist(){
            console.log(`연: ${this.year} / 월: ${this.month} / 플래너: ${this.planner} / 고객명: ${this.regName} / 생년월일: ${this.regNumber} / 치과: ${this.regHospital}`);

            if(this.regName && this.regNumber && this.regHospital) {
                this.$store.dispatch('insertCustomerInfo', { 
                                                            isReside: false
                                                            ,isFavorite: false
                                                            ,name: this.regName
                                                            ,regist_number: this.regNumber
                                                            ,phone: {telecom: '0',phone: ''}
                                                            ,address: {postal_code: '',address: '',extra_address: '',detail_address: ''}
                                                            ,bank_info: {name: '',number: ''}
                                                            ,planner: {planner01: {planner_id: this.planner_id, planner_name: this.planner},planner02: {planner_id: 0, planner_name: ''}}
                                                            ,complain: [{status: 'D', content: '', result: '', regDt: '', completeDt: ''}]
                                                            ,status: [[
                                                                        {
                                                                        "name": "개인정보동의완료",
                                                                        "code": "cs004",
                                                                        "class": "bg-warning",
                                                                        "color": "#344767",
                                                                        "date": ""
                                                                        },
                                                                        {
                                                                        "name": "청구예정",
                                                                        "code": "cs001",
                                                                        "class": "bg-warning",
                                                                        "color": "#FFD600",
                                                                        "date": ""
                                                                        },
                                                                        {
                                                                        "name": "청구중",
                                                                        "code": "cs005",
                                                                        "class": "bg-warning",
                                                                        "color": "#FF931E",
                                                                        "date": ""
                                                                        },
                                                                        {
                                                                        "name": "청구완료",
                                                                        "code": "cs002",
                                                                        "class": "bg-info",
                                                                        "color": "#90CAF9",
                                                                        "date": ""
                                                                        },
                                                                        {
                                                                        "name": "지급완료",
                                                                        "code": "cs003",
                                                                        "class": "bg-success",
                                                                        "color": "#2dce89",
                                                                        "date": ""
                                                                        },
                                                                        {
                                                                        "name": "차팅완료",
                                                                        "code": "cs006",
                                                                        "class": "bg-primary",
                                                                        "color": "#5e72e4",
                                                                        "date": ""
                                                                        },
                                                                        {
                                                                        "name": "반려",
                                                                        "code": "cs007",
                                                                        "class": "bg-danger",
                                                                        "color": "#ff0000",
                                                                        "date": ""
                                                                        }
                                                                    ]]
                                                            ,memo: ['']
                                                            ,memoDate: ['']
                                                            ,attach_file: []
                                                            ,contract: [{flag: false, date: '', price: '', company: ''}]
                                                            ,hospital_info: {introducer: '',introduce_company: '',hospital: this.regHospital,cure: '',hospital_discount: '',onmaum_discount: '',real_price: '',reservation_date: '',medical_date: '',regist: {year: this.year, month: this.month}}
                                                            ,insert_date: new Date().toLocaleString()
                                                            ,insert_id: this.$store.state.login.loginID
                                                            });

                this.$store.dispatch('insertRegistDB', {
                    year: this.year
                    ,month: this.month
                    ,planner: this.planner
                });

                setTimeout(() => {this.cancel();}, 1000); //위에 두 요청으로 DB 값이 바뀔 시간 확보 후 데이터 갱신
            } else {
                this.$store.commit('setAlert', {  'alertStatus': 'error'
                                                    ,'alertTitle': `DB 등록`
                                                    ,'alertContent': '필숫값을 입력해주세요!'});

            }
            
        },
    },

    computed: {
        // regions(){
        //     return this.$store.getters.getRegionInfo;
        // },

        hospitals(){
            return this.$store.getters.getHospitalInfo;
        },
    },

    mounted(){
        //지역 정보 가져오기
        //this.$store.dispatch('getRegionInfo');

        //치과 정보 가져오기
        this.$store.dispatch('getHospitalInfo');
    }
}
</script>

<style>
.db-regist-out {
    width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;

    justify-content: center;
    align-items: center;
    display: flex;
}

.db-regist-in{
    background: white;
    width: 50%;
    min-height: 30%;
    position: relative;
    margin: auto;
    border-radius: 8px;
}

</style>